<script>
export default {
  name: 'Var',
  render() {
    return this.$scopedSlots.default(this.$attrs);
  },
};
</script>
